import { render, staticRenderFns } from "./staffManage.vue?vue&type=template&id=55b7f33e"
import script from "./staffManage.vue?vue&type=script&lang=js"
export * from "./staffManage.vue?vue&type=script&lang=js"
import style0 from "./staffManage.vue?vue&type=style&index=0&id=55b7f33e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports